//IMPORTAÇÕES
import React, { useEffect, useState } from 'react';
import { Image } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import Paginador, { PaginationProvider } from 'react-bootstrap-table2-paginator';
import { connect, useDispatch, useSelector } from 'react-redux';

import SpinerVeye from '../../components/spinnerVeye/spinnerVeye.js';
import { api_gateway } from '../../conexoes/api';
import { atualizarMensagemCabecalhoSelecionada, atualizarMensagensCabecalho as atualizarMensagensCabecalhoFunc, limpadorFiltros, limpouBusca, mudarFiltros, mudarManejador, realizouBusca, revelarBarraFiltragem, revelarMensagemCabecalhoSelecionada as revelarMensagemCabecalho, revelarMensagemTabela } from "../../redux/actions/index";
import { envelopeAberto, envelopeFechado } from '../../utils/alternanciaIcones';
import decryptJWT from '../../utils/decryptJWT';
import { formatarData } from '../../utils/formatadorDataTabela';
//ICONES
//COMPONENTES
import PaginacaoTabela from '../../utils/paginacaoTabela';
import BarraDadosCliente from '../componentesModais/barraDadosCliente/barraDadosCliente';
import BarraFiltragem from '../componentesModais/barraFiltragem/barraFiltragem';
//REDUX
// COLETA CLICKSTREAM
// SPINER
//ESTILIZACAO
import '../../css/painelMensagens/painelMensagens.css';

let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 0
const valorLimite = 50

function PainelMensagens(){
   //SPINNER
   const [spinAtivo, setSpinAtivo] = useState(true);
   //HOOKS TABELA
   const [itens, setItens] = useState([]);
   const [paginaAtual, setPaginaAtual] = useState(1);

   //HOOKS REDUX
   const despacho = useDispatch();
   let conteudoBusca = useSelector(state => state.manejadorState.conteudoBusca);
   let limpouBuscaGeral = useSelector(state => state.manejadorState.limpouBusca);
   let realizouBuscaGeral = useSelector(state => state.manejadorState.realizouBusca);
   let filtros = useSelector(state => state.filtrosState.filtros);
   let revelarBarraFiltro = useSelector(state => state.filtrosState.revelarBarraFiltragem);
   let atualizarMensagensCabecalho = useSelector(state => state.mensagensState.atualizarMensagensCabecalho);
   let temFiltros = false;

   let itensVar = []

    useEffect(() => {
        function checarFiltros() {
            if (filtros.vazio == 'vazio') {
                temFiltros = false;
            } else {
                temFiltros = true;
            }
        }
        checarFiltros();
    }, [filtros]);

    useEffect(()=>{
        despacho(revelarBarraFiltragem(false))
        if(!filtros.vazio){
            despacho(mudarFiltros({vazio: 'vazio'}))
            despacho(revelarBarraFiltragem(false))
            despacho(limpadorFiltros(false))
        }
    }, [])

    useEffect(() => {
        setSpinAtivo(true)
        //despacho redux
        despacho(mudarManejador("mensagens"));
        async function carregarTabela(){
            //clicou no botão de limpar a busca geral e retorna tudo ao estado original
            if(limpouBuscaGeral){
                despacho(limpouBusca(false));
                restaurarConfigsIniciaisPagina()
            }

            //clicou no botão de busca geral
            if(realizouBuscaGeral){
                despacho(realizouBusca(false));
                restaurarConfigsIniciaisPagina()
            }    

            if(conteudoBusca  && !temFiltros){
                if(totalPaginas == 0){
                    contador = 0;
                    itensVar = [];
                    setItens([])
                    await contarItens();
                }
                else{
                    contador = (paginaAtual - 1) * valorLimite;
                }
                if (controladorPagina <= paginaAtual) {
                    await contarItens(); 
                    const { data } = await api_gateway.get('/m1/consultar/mensagem?buscar='+conteudoBusca+'&paginaAtual='+contador+'&carregarLimit='+valorLimite+'&cd_pav_usuario_destinatario='+decryptJWT('codigo'));
                    inserirData(data.dados)
                }
            }else if(temFiltros){
                if(totalPaginas == 0){
                    contador = 0;
                    itensVar = [];
                    setItens([])
                }else{
                    contador = (paginaAtual - 1) * valorLimite;
                }
                await contarItens();

                const dados = {
                    paginaAtual: contador,
                    carregarLimit: valorLimite,
                    filtros: filtros,
                    cd_pav_usuario_destinatario:decryptJWT('codigo')
                }
                if (controladorPagina <= paginaAtual) {
                    const { data } = await api_gateway.post("/m1/filtrar/mensagem", dados);
                    inserirData(data.dados)
                }
            }else{
                if(totalPaginas == 0){
                    await contarItens();
                }else{
                    contador = (paginaAtual - 1) * valorLimite;
                }
                if (controladorPagina <= paginaAtual) {
                    const { data } = await api_gateway.get('/m1/consultar/mensagem?'+'paginaAtual='+contador+'&carregarLimit='+valorLimite+'&cd_pav_usuario_destinatario='+decryptJWT('codigo'));
                    inserirData(data.dados)
                }
            }
            setSpinAtivo(false)
        }
        carregarTabela();
    }, [paginaAtual, conteudoBusca, filtros, atualizarMensagensCabecalho])

  
    function inserirData(data){
        if(data?.length === 0 && itens.length) setItens([]);

        for(let i=0;i<totalItens;i++){
            if (contador === i){
                let k = i
                for(let j=0;j<data.length;j++){
                itensVar[k] = data[j]
                k++
                }
            }
            if(i == (totalItens-1)){
                setItens(JSON.parse(JSON.stringify(itensVar)))
            }
        }
    }
  
    async function contarItens(){
        let arrayItens = []
        let apiData = []
        if (controladorPagina <= paginaAtual) { 
            if (controladorPagina <= paginaAtual && filtros.vazio) { 
                apiData = await api_gateway.get('/m1/consultar/mensagem?contar=true&buscar='+conteudoBusca+'&cd_pav_usuario_destinatario='+decryptJWT('codigo'));
            }else{
                const dados = {
                    paginaAtual: contador,
                    carregarLimit: valorLimite,
                    buscar:conteudoBusca,
                    filtros: filtros,
                    contar: true,
                    cd_pav_usuario_destinatario:decryptJWT('codigo')
                }
                apiData = await api_gateway.post("/m1/filtrar/mensagem", dados);
            }
            itensVar = []
            if(apiData.data.dados){
                totalItens = apiData.data.dados[0].CONTADOR;
                totalPaginas = Math.ceil(totalItens / valorLimite)
                for( var i = 0 ; i < totalItens; i++){
                    arrayItens.push(i)
                }
                itensVar = arrayItens
            }
        }
    }

    function restaurarConfigsIniciaisPagina(){
        totalPaginas = 0
        contador = 0
        controladorPagina = 1
        totalItens = 0
        setPaginaAtual(1)
    }



    const colunas = [{
        dataField: 'cd_msg_mensagem',
        text: 'ID',
        hidden:true,
        sort: true,
        headerClasses: 'tabela-coluna-primeira-header nao-selecionavel',
        headerStyle: () => {
            return { width: '130px'}
        },
        formatter: (cell) => {
            return <p className="fonte-cor-1 label-tabela-1">{cell}</p>;
        }
    },

    {
        dataField: 'fl_lido',
        headerClasses: 'nao-selecionavel',
        text: '',
        sort: true,
        formatter: (cell) => {
            if(cell == 0)
              return (
                <div className="container-envelope-mensagem-cabecalho-sistema">
                  <Image className="icone-email-dropdown-mensagem-cabecalho-sistema" src={envelopeFechado()} />
                </div>
              )  
            else
            return  (
                <div className="container-envelope-mensagem-cabecalho-sistema">
                  <Image className="icone-email-dropdown-mensagem-cabecalho-sistema" src={envelopeAberto()} />
                </div>
              )   
        }
    },


    {
        dataField: 'ds_mensagem_nivel',
        headerClasses: 'nao-selecionavel',
        text: 'Nível',
        sort: true,
        formatter: (cell) => {
            if(cell && cell == 'Atenção')
               return <div className="elipse-amarelo-mensagem-tabela" />;
            if(cell && cell == 'Normal')
               return <div className="elipse-verde-mensagem-tabela" />;
            if(cell && cell == 'Urgente')
               return <div className="elipse-vermelho-mensagem-tabela" />;
           
        }
    },

    {
        dataField: "dt_created_at",
        headerClasses: 'nao-selecionavel',
        text: 'Data',
        sort: true,
        formatter: (cell) => {
            return formatarData(cell);
        }
    },
    {
        dataField: 'ds_msg_mensagem_origem',
        headerClasses: 'nao-selecionavel',
        text: 'Origem',
        sort: true,
        formatter: (cell) => {
               return <p className="fonte-cor-1 label-tabela-1">{cell}</p>;
        }
    },

    {
        dataField: 'ds_titulo',
        headerClasses: 'nao-selecionavel',
        text: 'Assunto',
        sort: true,
        formatter: (cell) => {
               return <p className="fonte-cor-1 label-tabela-1">{cell}</p>;
        }
    },
   
    {
        dataField: 'tx_texto',
        headerClasses: 'nao-selecionavel',
        text: 'Mensagem',
        sort: true,
        formatter: (cell) => {
            if(cell){
                let texto = cell.replace( /(<([^>]+)>)/ig, "")
                if(texto && texto.length > 100)
                return <p className="fonte-cor-1 label-tabela-1">{texto.substring(0, 100)+'...'}</p>;
                else
                return <p className="fonte-cor-1 label-tabela-1">{texto}</p>;
           }
           return <p className="fonte-cor-1 label-tabela-1" />;

       }
    },

    ]

    async function abrirMensagem(mensagem){

        if(mensagem.fl_lido == 0){
            const cd_msg_mensagem = mensagem.cd_msg_mensagem;
            const bodyAlteracao ={
                condicao:{
                    cd_msg_mensagem_plataforma: cd_msg_mensagem
                },
                dados:{
                    fl_lido:1
                }
            }
            await api_gateway.post('/m1/alterar/mensagem',bodyAlteracao);
            despacho(atualizarMensagensCabecalhoFunc(!atualizarMensagensCabecalho))
        }
        

    }

    const eventosLinhas = {
        onClick: (e, row) => {
            abrirMensagem(row);
            despacho(atualizarMensagemCabecalhoSelecionada(row)) 
            despacho(revelarMensagemCabecalho(true)) 
            despacho(revelarMensagemTabela(true))
        }
    }

    const opcoesPaginacao = {
        page: paginaAtual,
        showTotal: true,
        sizePerPage: valorLimite,
        firstPageTitle: 'Primeira',
        lastPageTitle: 'Última',
        nextPageTitle: 'Proxima',
        prePageTitle: 'Anterior',
        custom: true,
        onPageChange:(page) => {setPaginaAtual(page)}
    }

    return(
        <div className='container-tela'>
        { spinAtivo && <div className="componente-spinner-overlay"><div className="componente-spinner-container"><SpinerVeye/></div></div> }
            <BarraDadosCliente/>
            {revelarBarraFiltro === true &&
                <BarraFiltragem/>
            }
            <PaginationProvider pagination={Paginador(opcoesPaginacao)} >
                {
                    ({
                        paginationProps,
                        paginationTableProps
                    }) => (
                        <>
                            <BootstrapTable
                                hover
                                condensed
                                keyField='ID' 
                                data={itens} 
                                columns={colunas} 
                                rowEvents={eventosLinhas}
                                bootstrap4
                                bordered={false}
                                classes="tabela"
                                noDataIndication={!spinAtivo && "Nenhum item encontrado"}
                                { ...paginationTableProps }
                            />
                             <PaginacaoTabela
                                setPaginaAtual={setPaginaAtual}
                                totalPaginas={totalPaginas}
                                totalItens={totalItens}
                                valorLimite={valorLimite}
                                paginaAtual={paginaAtual}
                                page={paginationProps.page}
                                onPageChange={paginationProps.onPageChange}
                            />
                        </>
                    )
                }
            </PaginationProvider>
            <div className="itens-exibidos-tabela fonte-cor-1">
                Mostrando 
                <span className="label-tabela-itens-exibidos">{contador + 1}</span>
                    - 
                <span className="label-tabela-itens-exibidos">{ contador + valorLimite <= totalItens ? contador + valorLimite : totalItens }</span>
                    de 
                <span className="label-tabela-itens-exibidos">{totalItens}</span>
            </div>
           
        </div>
    )
}

function mapStateToProps(state) {
    return { conteudoBusca: state.manejadorState.conteudoBusca, filtros: state.filtrosState.filtros };
} 
//React.memo - nao permitir a renderizacao se o state e o props nao mudarem de estado
export default connect(mapStateToProps)(React.memo(PainelMensagens));